<template>
	<div class="auth d-flex justify-content-center align-items-center">
		<div class="auth__form theme-bg">
			<h3 class="auth__form__heading py-2 pl-4">
				Activate
				<span class="auth__form__heading--span-highlight">Account</span>
			</h3>
			<form @submit.prevent="activateUser">
				<vs-input
					v-model="activationPin"
					color="#FAF7FD"
					class="auth__input-parent my-45"
					required
					label-placeholder="6-Digit Code"
					icon-after
					@keypress="numberValidation"
				>
					<!-- type="text" -->
					<template #icon>
						<i class="">
							6c
						</i>
					</template>
					<template v-if="error.expression" #message-danger>
						{{ error.message }}
					</template>
				</vs-input>
				<div
					class="auth__form__extra-action mb-3 text-light d-flex justify-content-end align-items-center"
				>
					<span
						@click="resendActivationCode"
						class="auth__form__extra-action__forgot-password light-link"
					>
						Resend Activation Code?
					</span>
				</div>
				<vs-button
					size="large"
					color="#362EB8"
					type="submit"
					class="d-block m-auto w-50"
				>
					Verify
				</vs-button>
			</form>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex"
import notifier from "@/components/mixins/notifier"

export default {
	components: {},
	mixins: [notifier],
	mounted() {
		if (!this.actionToken) {
			this.$router.push({ name: "register" })
		}
	},

	computed: {
		...mapState("register", ["actionToken"])
	},

	data: () => ({
		activationPin: "",
		error: {
			expression: "",
			message: ""
		}
	}),

	methods: {
		...mapMutations("register", ["SET_ACTION_TOKEN"]),
		...mapActions("register", ["ACTIVATE_USER", "RESEND_ACTIVATION_CODE"]),

		async activateUser() {
			const length = this.activationPin.length
			if (length < 6 || length > 6) {
				this.error = {
					expression: true,
					message: "Required minimum 6 digits!"
				}
				return
			}
			const { success, msg } = await this.ACTIVATE_USER({
				activationPin: this.activationPin,
				actionToken: this.actionToken
			})
			if (success) {
				this.openNotification("Account Activation", msg)
				this.SET_ACTION_TOKEN("")
				this.$router.push({ name: "index" })
			}
		},
		async resendActivationCode() {
			const { msg } = await this.RESEND_ACTIVATION_CODE(this.actionToken)
			this.openNotification("Account Activation", msg)
		},
		numberValidation(evt) {
			let theEvent = evt || window.event
			const length = this.activationPin.length
			let key
			// Handle paste
			if (theEvent.type === "paste") {
				key = event.clipboardData.getData("text/plain")
			} else {
				// Handle key press
				key = theEvent.keyCode || theEvent.which
				key = String.fromCharCode(key)
			}
			let regex = /[0-9]|\./
			if (length === 6) {
				this.error = {
					expression: false,
					message: ""
				}
			}
			if (!regex.test(key) || length === 6) {
				theEvent.returnValue = false
				if (theEvent.preventDefault) theEvent.preventDefault()
			}
		}
	}
}
</script>

<style>
@import url("../../../assets/styles/bootstrap5.css");
.activate-account {
	width: 100vw;
	height: calc(100vh - 84px);
}
.activate-account__form {
	width: 450px;
	/* min-height: 400px; */
	padding: 1rem;
}
.activate-account__form p {
	text-align: left;
	/* transform: tr; */
}
.activate-account__form * {
	color: white;
	/* transform: tr; */
}
.activate-account__form input {
	background-color: rgb(75, 75, 75);
	width: 100%;
	/* transform: tr; */
}
</style>
